import { Component, OnInit } from '@angular/core';
import {
  NgxFileDropEntry,
  FileSystemFileEntry,
  FileSystemDirectoryEntry
} from 'ngx-file-drop';
import Swal from 'sweetalert2/dist/sweetalert2.all.js'; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

import * as XLSX from 'xlsx';
import { ArchivosService } from '../servicios/archivos.service';
import { Utils } from '../utils/utils';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AgenciaService } from '../servicios/agencia.service';
import { ServicioGestionCargueService } from '../servicios/servicio-gestion-cargue.service';

@Component({
  selector: 'app-gestion-maestras',
  templateUrl: './gestion-maestras.component.html',
  styleUrls: ['./gestion-maestras.component.css']
})
export class GestionMaestrasComponent implements OnInit {

  cargueGroup: FormGroup;
  //public files: UploadFile[] = [];
  files:any;
  AOA: any[][];
  data: any;
  item = {
    relativePath: ''
  };
  arcihvoValido = false;
  resultadoCargue = {};
  sinErrores = true;
  infoCargue: any;
  errorCargue: any;
  respuestaIntegracion: any;
  procesandoCargue = false;
  escondeProcesar = false;
  erroresResultado = [];
  loadingAgencias=false;

  agencias: any[] = [];

  constructor(
    public ruta: Utils,
    private servicioArchivo: ArchivosService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private servicioAgencia:AgenciaService,
    private servicioGestionCargue: ServicioGestionCargueService,
  ) {
    const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
    this.loadingAgencias=true;
    this.servicioAgencia.getAgencia(infoUsuario[0].IdUsuario, 0)//se envia cero para devolver todas las agencias y el id de agencia para devovler una especifica
    .subscribe(result=>{
      this.agencias=result;
      this.loadingAgencias=false;
    });

    this.cargueGroup = this.fb.group({
      IdAgencia: ['']
    });
  }

  ngOnInit() {
    this.ruta.setRuta();
  }

  public dropped(event: NgxFileDropEntry[]) {

    const agencia = this.cargueGroup.controls['IdAgencia'].value;
    const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));

    if (!agencia) {
      Swal.fire('Error Cargue Archivo!', 'Seleccione una agencia e intente cargar de nuevo.', 'error');
      return;
    }

    this.files = event ;
    for (const droppedFile of this.files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          // Here you can access the real file

          console.log('aqui subo');
          console.log(droppedFile.relativePath, file);

          this.servicioArchivo.postArchivo(agencia, infoUsuario[0].IdUsuario, file, droppedFile.relativePath)
            .subscribe(result => {
              if (result.errores.length == 0) {
                this.arcihvoValido = true;
                this.sinErrores = true;
                this.escondeProcesar = false;
                this.respuestaIntegracion = '';
                this.snackBar.open('Archivo Validado Correctamente', 'Cargar Archivo', {
                  duration: 2000
                });
              }
              else {
                this.arcihvoValido = false;
                this.sinErrores = false;
                this.resultadoCargue = result;
              }

              console.log('si cargooooo');
              this.item.relativePath = droppedFile.relativePath;
              console.log(JSON.stringify(result));
              this.infoCargue = result;
            });

        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(droppedFile.relativePath, fileEntry);
      }
    }
  }


  public droppedXLS(event: NgxFileDropEntry[]) {

    this.files = event;
    for (const droppedFile of this.files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          // Here you can access the real file

          console.log('aqui subo');
          console.log(droppedFile.relativePath, file);

          this.servicioArchivo.postArchivo(1,1, file, droppedFile.relativePath)
            .subscribe(result => {
              console.log('si cargooooo');
              this.item.relativePath = droppedFile.relativePath;
              console.log(JSON.stringify(result));
            });
          const reader: FileReader = new FileReader();
          reader.onload = (e: any) => {
            /* read workbook */
            const bstr: string = e.target.result;
            const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

            /* grab first sheet */
            const wsname: string = wb.SheetNames[0];
            const ws: XLSX.WorkSheet = wb.Sheets[wsname];

            /* save data */
            this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
            console.log(JSON.stringify(this.data));
          };
          console.log(this.files[0].fileEntry);
          reader.readAsBinaryString(file);
          /**
          // You could upload it like this:
          const formData = new FormData()
          formData.append('logo', file, relativePath)

          // Headers
          const headers = new HttpHeaders({
            'security-token': 'mytoken'
          })

          this.http.post('https://mybackend.com/api/upload/sanitize-and-save-logo', formData, { headers: headers, responseType: 'blob' })
          .subscribe(data => {
            // Sanitized logo returned from backend
          })
          **/
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(droppedFile.relativePath, fileEntry);
      }
    }
  }

  public fileOver(event) {
    console.log(event);
  }

  public fileLeave(event) {
    console.log(event);
  }

  procesarCargue() {
    const agencia = this.cargueGroup.controls['IdAgencia'].value;
    const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
    const jsonCargue = {
      agencia: agencia,
      idUsuario: infoUsuario[0].IdUsuario,
      rutaArchivo: this.infoCargue.ruta,
      nombreArchivo:this.infoCargue.nombreArchivo,
      totalCols:this.infoCargue.totalCols
    };
    this.procesandoCargue = true;
    this.servicioArchivo.postProcesoCargue(jsonCargue)
      .subscribe(result => {
        //console.log(JSON.stringify(result));
        this.procesandoCargue = false;
        this.respuestaIntegracion = result[0].respuestaIntegracion;
        this.errorCargue = result[0].error;
        if (this.errorCargue) {
          let i = 0;
          result.forEach(element => {
            if (i > 1) {
              this.erroresResultado.push(element);
            }
            i++;
          });
        }
        else{
          Swal.fire({
            title: "Cargues",
            text: "Desea sincronizar todos los cargues pendientes al estado \"en ruta\".",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: '#127570',
            allowOutsideClick: false,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Si, Sincronizar!",
          }).then((result) => {
            if (result.value) {
              Swal.fire({
                title: 'Sincronizado Entregas !',
                html: 'Un momento por favor.',// add html attribute if you want or remove
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: false,
                showConfirmButton: false,
                onBeforeOpen () {
                  Swal.showLoading ();
                },
                // willOpen: () => {
                //   Swal.showLoading();
                // },
              });
              
  
              this.servicioGestionCargue
              .EntregasProcesar(agencia,0)
              .subscribe(()=>{
                
                Swal.close();
                Swal.fire("Entregas!", "Sincronizados todos los cargues al estado en ruta.", "success");
              });
            }
          }
          );
        }
        //console.log(JSON.stringify(this.erroresResultado));
        this.escondeProcesar = true;
      }, err =>{
        this.procesandoCargue = false;
        this.escondeProcesar = true;
      });
  }
}
